import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { AuthService } from './auth.service';
import { Globals } from '../shared/globals';
import { OverAllChargingStatistics } from '../models/statistics/overall-charging-statistics.model';
import { JsonSerializer } from 'typescript-json-serializer';
import { Api } from '../shared/api';

@Injectable()
export class StatisticsService {
  private jsonSerializer = new JsonSerializer();

  constructor(
    private readonly http: HttpClient,
    private readonly authService: AuthService,
    private readonly globals: Globals,
    private readonly api: Api
  ) {

  }

  async getStatistics(
    startDate: Date,
    endDate: Date
  ): Promise<OverAllChargingStatistics> {
    let url = this.globals.apiUrl('statistics/stations');
    url += "?startDate=" + startDate.toISOString();
    url += "&endDate=" + endDate.toISOString();

    const result: string = await this.api.httpGet(url);

    return this.jsonSerializer.deserializeObject(result, OverAllChargingStatistics);
  }
}
